<ng-container *transloco="let t">
  <div class="header-alt">
    <app-grid-item-title [title]="title" [isMediumSize]="true" [isBold]="isBold" [isSemiBold]="isSemiBold"/>
  </div>
</ng-container>
